import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface PrivilegeState {
    privileges: object
    userPrivileges: number[]
}

const initialState: PrivilegeState = {
    privileges: {},
    userPrivileges: []
}

const privilegeSlice = createSlice({
    name: 'privilege',
    initialState,
    reducers: {
        setPrivileges: (state, action: PayloadAction<object>) => {
            state.privileges = action.payload
        },
        setUserPrivileges: (state, action: PayloadAction<number[]>) => {
            state.userPrivileges = action.payload
        }
    }
})

export const {setPrivileges, setUserPrivileges} = privilegeSlice.actions
export default privilegeSlice.reducer